export class createStartStopTimeResourceModel {
  constructor(startTime, endTime) {
    this.siteStartTime = startTime;
    this.siteEndTime = endTime;
  }
}
